export const TEMPERATURA_V1ResourcesDE: TEMPERATURA_V1ResourcesBSInterface = {
  labelDone: "Datum der Aufgabenerledigung",
  errorMissingInput: "Bitte füllen Sie alle Felder aus",
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
  input: {
    signatureTitle: "Unterschrift",
    datum: {
      label: "Bitte geben Sie das Datum ein",
      placeholder: "Bitte geben Sie das Datum ein",
      name: "datum",
    },
    ocitanaTemperatura: {
      label: "Abgelesene Temperatur",
      name: "ocitanaTemperatura",
      placeholder: "Bitte geben Sie die abgelesene Temperatur ein",
    },
    dozvoljenaTempMin: {
      label: "Minimal erlaubte Temperatur",
      name: "dozvoljenaTempMin",
      placeholder: "Bitte geben Sie die Mindesttemperatur ein",
    },
    dozvoljenaTempMax: {
      label: "Maximal erlaubte Temperatur",
      name: "dozvoljenaTempMax",
      placeholder: "Bitte geben Sie die Höchsttemperatur ein",
    },
    dozvoljenoOdstupanje: {
      label: "Erlaubte Abweichung",
      name: "dozvoljenoOdstupanje",
      placeholder: "Bitte geben Sie die erlaubte Abweichung ein",
    },
    stanje: {
      label: "Liegt der Zustand außerhalb der erlaubten Werte?",
    },
    vrijemeKorekcije: {
      label: "Korrekturzeit auswählen",
      name: "vrijemeKorekcije",
      placeholder: "Korrekturzeit auswählen",
    },
    opisMjeereKorekcije: {
      label: "Beschreibung der Korrekturmaßnahme",
      name: "opisMjeereKorekcije",
      placeholder: "Beschreibung der Korrekturmaßnahme auswählen",
    },
    ocitanaTemperaturaKorekcije: {
      label: "Abgelesene Korrekturtemperatur",
      name: "ocitanaTemperaturaKorekcije",
      placeholder: "Bitte geben Sie die abgelesene Korrekturtemperatur ein",
    },
    dozvoljenaTempMinKorekcije: {
      label: "Minimal erlaubte Korrekturtemperatur",
      name: "dozvoljenaTempMinKorekcije",
      placeholder: "Bitte geben Sie die minimale Korrekturtemperatur ein",
    },
    dozvoljenaTempMaxKorekcije: {
      label: "Maximal erlaubte Korrekturtemperatur",
      name: "dozvoljenaTempMaxKorekcije",
      placeholder: "Bitte geben Sie die maximale Korrekturtemperatur ein",
    },
    dozvoljenoOdstupanjeKorekcije: {
      label: "Erlaubte Korrekturabweichung",
      name: "dozvoljenoOdstupanjeKorekcije",
      placeholder: "Bitte geben Sie die erlaubte Korrekturabweichung ein",
    },
    imePrezimeKorekcije: {
      name: "imePrezimeKorekcije",
      placeholder: "Bitte geben Sie Vor- und Nachname für Korrektur ein",
      label: "Bitte geben Sie Vor- und Nachname ein",
    },
    potpisIzvrsiocaKorekcije: {
      label: "Unterschrift des Korrekturdurchführers",
    },
  },
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
};

interface InputField {
  label: string;
  name?: string;
  placeholder?: string;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  ocitanaTemperatura: InputField;
  dozvoljenaTempMin: InputField;
  dozvoljenaTempMax: InputField;
  dozvoljenoOdstupanje: InputField;
  stanje: InputField;
  vrijemeKorekcije: InputField;
  opisMjeereKorekcije: InputField;
  ocitanaTemperaturaKorekcije: InputField;
  dozvoljenaTempMinKorekcije: InputField;
  dozvoljenaTempMaxKorekcije: InputField;
  dozvoljenoOdstupanjeKorekcije: InputField;
  imePrezimeKorekcije: InputField;
  potpisIzvrsiocaKorekcije: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface TEMPERATURA_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: IErrors;
}
